import * as React from 'react';
import { render } from 'react-dom';
import { CityJobs } from '../landing_pages/pages/CityJobs';
import '../terms_and_conditions/styles.scss';

const root = document.getElementById('city_jobs');
render(<CityJobs />, root);
